import React from "react";
import { useParams, Link, Navigate } from "react-router-dom";
import { Calendar, ArrowLeft, ArrowUpRight } from "lucide-react";
import { newsItems } from "../lib/content";
import { PageHeader } from "../components/PageHeader";

export default function HaberlerDetail() {
  const { slug } = useParams();
  const item = newsItems.find((n) => n.slug === slug);
  if (!item) return <Navigate to="/haberler" replace />;

  const related = newsItems.filter((n) => n.slug !== slug).slice(0, 3);

  return (
    <>
      <PageHeader eyebrow={item.cat} title={item.title} description={item.desc} image={item.image} />

      <article className="py-16 md:py-20">
        <div className="max-w-3xl mx-auto px-5 lg:px-8">
          <Link
            to="/haberler"
            className="inline-flex items-center gap-2 text-sm text-slate-500 hover:text-brand-gold mb-8 transition-colors"
            data-testid="news-back-link"
          >
            <ArrowLeft className="w-4 h-4" /> Tüm Haberler
          </Link>

          <div className="flex items-center gap-4 text-sm text-slate-500 mb-8 pb-8 border-b border-slate-200">
            <span className="flex items-center gap-1.5">
              <Calendar className="w-4 h-4" />
              {item.date}
            </span>
            <span className="px-2.5 py-1 rounded-md bg-brand-gold/15 text-brand-gold text-[10px] uppercase tracking-[0.2em] font-bold">
              {item.cat}
            </span>
          </div>

          <div className="space-y-6">
            {item.content.map((p, i) => (
              <p key={i} className="text-slate-700 text-base md:text-lg leading-relaxed">
                {p}
              </p>
            ))}
          </div>

          <div className="mt-16 pt-8 border-t border-slate-200">
            <Link
              to="/iletisim"
              className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-slate-950 text-white text-sm font-semibold hover:bg-brand-gold transition-colors group"
            >
              Bize Ulaşın
              <ArrowUpRight className="w-4 h-4 group-hover:rotate-45 transition-transform" />
            </Link>
          </div>
        </div>
      </article>

      <section className="bg-slate-50 py-16">
        <div className="max-w-7xl mx-auto px-5 lg:px-8">
          <h3 className="font-display text-2xl md:text-3xl font-bold text-slate-950 tracking-tight mb-8">
            Diğer Haberler
          </h3>
          <div className="grid md:grid-cols-3 gap-5">
            {related.map((n) => (
              <Link
                key={n.slug}
                to={`/haberler/${n.slug}`}
                className="group p-7 rounded-2xl bg-white border border-slate-200 hover:border-slate-950 transition-all"
              >
                <span className="px-2.5 py-1 rounded-md bg-brand-gold/15 text-brand-gold text-[10px] uppercase tracking-[0.2em] font-bold inline-block mb-4">
                  {n.cat}
                </span>
                <h4 className="font-display text-lg font-bold text-slate-950 mb-2 leading-tight group-hover:text-brand-gold transition-colors">
                  {n.title}
                </h4>
                <p className="text-sm text-slate-600 leading-relaxed">{n.desc}</p>
              </Link>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
